<div class="card-interactive" (click)="onButtonPress()" (keydown.enter)="onButtonPress()" [tabIndex]="0">
	<span class="icon bpi__icon-plus"></span>
	<span class="text">{{ locaKey | translate }}</span>
</div>
